import { PROJECT_TABS } from "../components/project-tabs"
import { useUser } from "../user-context"
import { usePropertyMemberships } from "./use-property-memberships"

/**
 * PROJECT_TABS filtered for the current viewer, mirroring
 * `useVisiblePropertyTabs`: Budget (ZPL-224) is PROPERTY-OWNER-only — the
 * API 404s everyone else, so the tab would only dead-end project members.
 * Hidden while memberships load (appearing beats disappearing).
 */
export function useVisibleProjectTabs(propertyId: string) {
	const { profile } = useUser()
	const memberships = usePropertyMemberships(propertyId)
	const isOwner =
		memberships.data !== undefined && memberships.data.owner.id === profile?.id
	return PROJECT_TABS.filter((tab) => tab.key !== "budget" || isOwner)
}
